import React, { useState, useEffect } from "react";
import SideBar from "../../components/ThirdPartyDashboard/SideBar";
// import Search from "../../components/ThirdPartyDashboard/Search";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  facilityVerify,
} from "../../apis/General/web3/shared";
import {
  getCommentThread,
  getCommentThreadByDateRange,
  createVerifierComment,
  adminReplyToComment,
} from "../../apis/AdminDashboard/users";
import "../../styles/ThirdParty/Verification.scss";
import { useSelector } from "react-redux";
import {
  getThreeMonthUnverifiedAccumulationsForPlant,
  getIndividualEmissionsForCard,
  getThreeMonthUnverifiedAccumulationsAll,
  getThreeMonthUnverifiedAccumulationCardsForPlant,
} from "../../instantiateTransaction/basicGreenProject";
import { toast } from "react-toastify";
import { getUserDetails } from "../../apis/ThirdPartyDashboard/dashboard";
import { getFacilityDataForVerification } from "../../apis/AdminDashboard/users";
import { useQuery } from "@tanstack/react-query";
function Web3VerificationData() {
  const { params } = useParams();
  const { id } = useParams();
  const { plantId } = useParams();
  const { rangeStartDate } = useParams();
  const { rangeEndDate } = useParams();
  const { totalEd } = useParams();
  const { baseline } = useParams();
  const { totalC } = useParams();
  console.log("end", rangeEndDate);
  console.log("start", rangeStartDate);
  console.log("id", id);
  const [plantData, setPlantData] = useState(null);
  const [unverifiedData, setUnverifiedData] = useState({});
  //   const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [openVerifyModal, setOpenVerifyModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [comment, setComment] = useState("");
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [walletAddress, setWalletAddress] = useState(id);
  const [commentThread, setCommentThread] = useState([]);
  const [commentLoading, setCommentLoading] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replyingToCommentId, setReplyingToCommentId] = useState(null);
  const [currentThreadId, setCurrentThreadId] = useState(null)
    const [success, setSuccess] = useState(false);
  ;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const recordsPerPage = 8;

  const auth = useSelector((state) => state.auth);
  const methodologyUrl = useSelector((state) => state.verifier?.methodologyUrl);
  const normalizedMethodologyUrl = methodologyUrl
    ? /^https?:\/\//i.test(methodologyUrl)
      ? methodologyUrl
      : `https://${methodologyUrl}`
    : null;

  // Modal handlers
  const handleCloseCommentModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setOpenCommentModal(false);
      setIsClosing(false);
    }, 300);
  };

  const handleCloseVerifyModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setOpenVerifyModal(false);
      setIsClosing(false);
    }, 300);
  };

  const handleCommentSubmit = async () => {
    if (!comment.trim()) {
      toast.error("Please enter a comment");
      return;
    }

    try {
      setCommentLoading(true);
      console.log("Comment submitted:", comment);

      const plantAddress = unverifiedDataGreen?.walletAddress || unverifiedDataGreen?.plantAddress;

      if (!plantAddress) {
        toast.error("Plant address not found");
        return;
      }

      // Create unique contextId for this reporting period
      const contextId = `${plantAddress}_${unverifiedDataGreen?.rangeStartDate || ''}_${unverifiedDataGreen?.rangeEndDate || ''}`;

      // If replying to existing thread, use threadId; otherwise create new thread with contextId
      const submitComment = await createVerifierComment(
        plantAddress,
        comment,
        auth?.token,
        currentThreadId,  // Pass threadId if replying, null if new thread
        contextId,        // Pass contextId to link comment to this reporting period
        unverifiedDataGreen?.rangeStartDate,  // Pass rangeStartDate separately
        unverifiedDataGreen?.rangeEndDate     // Pass rangeEndDate separately
      );

      console.log("Comment Submission Response:", submitComment);
      const body = submitComment?.data;
      if (body?.status !== "success") {
        throw new Error(body?.message || "Failed to submit comment");
      }

      // Store threadId from new thread or reply
      if (submitComment?.data?.data?.threadId) {
        setCurrentThreadId(submitComment.data.data.threadId);
      }

      toast.success("Comment submitted successfully!");

      setComment("");
      setOpenCommentModal(false);

      // Trigger immediate refresh on Verification page
      window.dispatchEvent(new CustomEvent('commentAdded', {
        detail: {
          plantAddress,
          rangeStartDate: unverifiedDataGreen?.rangeStartDate,
          rangeEndDate: unverifiedDataGreen?.rangeEndDate
        }
      }));

      // Refresh comment thread immediately
      // await fetchCommentThread();
    } catch (err) {
      console.error("Error submitting comment:", err);
      toast.error(err?.response?.data?.message || "Failed to submit comment. Please try again.");
    } finally {
      setVerificationLoading(false);
    }
    // Add your API call for comment submission here
  };

  const handleVerifyConfirm = async () => {
    try {
      setVerificationLoading(true);
      const response = await facilityVerify(unverifiedDataGreen.plantAddress, "green", "basic", auth?.token);
      const body = response?.data;
  setSuccess(true)

      // toast.success(body.message || "Facility verified successfully!");
      setOpenVerifyModal(false);
      // Refresh data after verification
      fetchAllUnverifiedAccumulations();
      if (id) {
        getThreeMonthUnverifiedAccumulationsForPlantData(id);
      }
    } catch (err) {
      console.error("Error verifying facility:", err);
      toast.error(err?.response?.data?.message || err.message || "Failed to verify facility. Please try again.");
    } finally {
      setVerificationLoading(false);
    }
  };
    const handleCloseOverlay = () => {
    setSuccess(false);
  };

  
  const getThreeMonthUnverifiedAccumulationsForPlantData = async (address) => {
    try {
      //   setLoading(true);
      setError(null);
      const result = await getThreeMonthUnverifiedAccumulationCardsForPlant(
        address,
      );
      console.log("Three Month Unverified Accumulations for Plant:", result);
      //   setPlantData(result);
    } catch (err) {
      console.error("Error fetching data for plant:", err);
      setError(err.message || "Failed to fetch plant data");
    } finally {
      //   setLoading(false);
    }
  };

  const fetchAllUnverifiedAccumulations = async () => {
    try {
      //   setLoading(true);
      setError(null);

      const result = await getIndividualEmissionsForCard(
        plantId,
        rangeStartDate,
        rangeEndDate,
      );
      console.log("All Unverified Data:", result);
      setWalletAddress(result?.plantAddress || id);

      setUnverifiedData(result);
    } catch (err) {
      console.error("Error fetching all unverified accumulations:", err);
      setError(err.message || "Failed to fetch unverified data");
    } finally {
      //   setLoading(false);
    }
  };

  // Transform the console data into table rows
  const transformDataToTableRows = () => {
    const rows = [];

    if (
      unverifiedData?.individualEmissions &&
      Array.isArray(unverifiedData.individualEmissions)
    ) {
      unverifiedData.individualEmissions.forEach((emission, index) => {
        // Create table row data from individual emission
        const rowData = {
          id: index + 1,
          date: emission.date || "N/A",
          projectEmission: `${emission.totalGHGEmission || "0.00"}tCO2e`,
          baselineEmission: `${emission.quantifiedGHGEmissionsInBaselineScenario || "0.00"
            }tCO2e`,
          energyConsumption: `${emission.energyConsumptionInKWh || "0.00"}kWh`,
          emissionReduction: calculateEmissionReduction(emission),
          plantAddress: unverifiedData.plantAddress,
          facilityName: plantData?.facilityName || "Unknown Facility",
        };

        rows.push(rowData);
      });
    }

    return rows;
  };

  // Calculate emission reduction
  const calculateEmissionReduction = (plantData) => {
    const baseline =
      parseFloat(plantData.quantifiedGHGEmissionsInBaselineScenario) || 0;
    const project = parseFloat(plantData.totalGHGEmission) || 0;

    if (baseline > project) {
      return `${(baseline - project).toFixed(4)}tCO2`;
    }
    return "0.0000tCO2";
  };

  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handleRefresh = () => {
    fetchAllUnverifiedAccumulations();
    if (id) {
      getThreeMonthUnverifiedAccumulationsForPlantData(id);
    }
  };
  const formatDate = (value) => {
    if (!value) return "";

    const iso = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      const [, year, month, day] = iso;
      return `${day}/${month}/${year}`;
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${d.getFullYear()}`;
  };
  const getUserData = async () => {
    try {
      const userData = await getUserDetails(auth?.token, auth?.userInfo?.id);
      console.log("User Data for verifier:", userData);
      // You might want to set this data to state if you need to use it in your component
      // setUserData(userData);
    } catch (err) {
      console.error("Error fetching user data:", err);
    }
  };
  // useEffect hooks
  useEffect(() => {
    getUserData();
    // fetchCommentThread()
  }, [auth?.token]); // Removed plantAddress dependency since it's not used in getUserData

  //   useEffect(() => {
  //     fetchAllUnverifiedAccumulations();
  //     if (id) {
  //       getThreeMonthUnverifiedAccumulationsForPlantData(id);
  //     } else {
  //       setError("No plant address provided");
  //     //   setLoading(false);
  //     }
  //   }, [id]);

  const { index: idParam } = useParams();
  const index = Number(idParam);
  const isValidIndex = Number.isInteger(index) && index >= 0;

  // unverified green facility
  const {
    data: getFacilityDataFromBackendGreen = [],
    loading,
    isLoading: greenUnverifiedLoading,
    isError: errorUnverifiedgreen,
  } = useQuery({
    queryKey: ["facilities-kyc"],
    queryFn: ({ signal }) => getFacilityDataForVerification({ signal }),
    staleTime: 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    select: (res) =>
      (res?.cards ?? []).filter((f) => f?.facilityCategory === "green"),
  });
  console.log(
    "facilities-data-from-backend-green",
    getFacilityDataFromBackendGreen,
  );
  const unverifiedDataGreen = getFacilityDataFromBackendGreen[index];
  console.log("single", unverifiedDataGreen);

  
const allRows = unverifiedDataGreen?.dailyBreakdown ?? [];
  const totalPages = Math.ceil(allRows.length / recordsPerPage);
  const indexOfFirstRecord = (currentPage - 1) * recordsPerPage;
  const currentRecords = allRows.slice(
    indexOfFirstRecord,
    indexOfFirstRecord + recordsPerPage,
  );
  // const handleVerifyConfirm = async () => {
  //   try {
  //     setVerificationLoading(true);
  //     await facilityVerify(unverifiedDataGreen.plantAddress, "green", "basic", auth?.token);
  //     setOpenVerifyModal(false);
  //     // Refresh data after verification
  //     fetchAllUnverifiedAccumulations();
  //     if (id) {
  //       getThreeMonthUnverifiedAccumulationsForPlantData(id);
  //     }
  //   } catch (err) {
  //     console.error("Error verifying facility:", err);
  //     alert("Failed to verify facility. Please try again.");
  //   } finally {
  //     setVerificationLoading(false);
  //   }
  // };

  useEffect(() => {
    setCurrentPage(1);
  }, [index]);

  useEffect(() => {
    if (unverifiedDataGreen) {
      // fetchCommentThread();
    }
  }, [unverifiedDataGreen]);

  return (
    <div className="thirdparty_verification">
      <div className="sidebar_container">
        <SideBar />
      </div>


      <div className="main">
        {/* Back Button */}
        <Link to="/third-party/verification" className="flex items-center gap-2 mb-6 text-[#667085] hover:text-[#101828] transition-colors">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8334 10H4.16675M4.16675 10L10.0001 15.8333M4.16675 10L10.0001 4.16667" stroke="currentColor" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="font-medium text-[14px] leading-5">Back</span>
        </Link>

        {unverifiedDataGreen && !loading && (
          <div className="flex flex-col items-end p-0 gap-4 w-full max-w-[1155px] mx-auto">
            {/* Action Buttons */}
            <div className="flex flex-row justify-end items-start p-0 gap-5 w-full h-[59px]">
              {/* Leave Comment Button */}
              <button
                className="flex flex-row justify-center items-center p-2 gap-2 w-[167px] h-[59px] box-border border border-[#006633] rounded-lg hover:bg-gray-50 transition-colors"
                onClick={() => setOpenCommentModal(true)}
              >
                <span className="w-[135px] h-6 font-inter font-semibold text-[16px] leading-6 text-center bg-gradient-to-r from-[#006633] to-[#00AED9] bg-clip-text text-transparent">
                  Leave Comment
                </span>
              </button>

              {/* Verify Button */}
              <button
                className="flex flex-row justify-center items-center p-2 gap-3 w-[154px] h-[59px] bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity"
                onClick={() => setOpenVerifyModal(true)}
              >
                <span className="w-[46px] h-6 font-inter font-semibold text-[16px] leading-6 text-white">
                  Verify
                </span>
              </button>
            </div>

            {/* Plant Information Card */}
            <div className="flex flex-row  p-15 gap-16 w-full h-[208px] mt-[30px] bg-[#FAFAFA] rounded-lg">
              <div className="flex flex-row items-start  gap-12 h-[144px] p-12 py-16">
                {/* Organization & Date Info */}
                <div className="flex flex-col items-start p-0 gap-4">
                  {/* Organization Name */}
                  <div className="flex flex-row items-center p-0 gap-3 w-full h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-normal">
                      Organisational Name:
                    </span>
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-medium">
                      {unverifiedDataGreen?.facilityName || ""}
                    </span>
                  </div>

                  {/* Reporting Period */}
                  <div className="flex flex-row p-0 gap-3 w-full h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-normal">
                      Reporting period:
                    </span>
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-medium">
                      {unverifiedDataGreen.reportingPeriod || "Quarterly"}
                    </span>
                  </div>

                  {/* Date Range */}
                  <div className="flex flex-row p-0 gap-3 w-full">
                    <span className="h-6 text-[16px] text-[#101828] font-normal">
                      Date:
                    </span>
                    <div className="text-[16px] text-[#101828] font-medium">
                      {unverifiedDataGreen.rangeStartDate || "no date"} -{" "}
                      {unverifiedDataGreen.rangeEndDate || "date"}
                    </div>
                  </div>

                  
                  {/* Facility Capacity */}
                  <div className="flex flex-row p-0 gap-3 h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-normal">
                      Facility capacity:
                    </span>
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-medium">
                      {/* {unverifiedDataGreen.facilityCapacity || "0.00"}tCO2e
                       */}
                       N/A
                    </span>
                  </div>
                </div>

                {/* Emission Data */}
                <div className="flex flex-col p-0 gap-4">
                  {/* Total Project Emission */}
                  <div className="flex flex-row p-0 gap-6 h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-normal">
                      Total Project emission data:
                    </span>
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-medium">
                      {unverifiedDataGreen.totalGHGEmission || ""}tCO2e
                    </span>
                  </div>

                  {/* Total Baseline Emission */}
                  <div className="flex flex-row p-0 gap-4 h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-normal">
                      Total Baseline emission data:
                    </span>
                    <span className="w-[94px] h-6  text-[16px] leading-6 text-[#101828]">
                      {unverifiedDataGreen.quantifiedGHGEmissionsInBaselineScenario ||
                        "0.00"}
                      tCO2e
                    </span>
                  </div>

                  {/* Total Energy Consumption */}
                  <div className="flex flex-row p-0 gap-8 h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-text-[#101828] font-normal">
                      Total Energy consumption:
                    </span>
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-medium">
                      {unverifiedDataGreen.energyConsumptionInKWh || "0.00"}kWh
                    </span>
                  </div>

                  {/* Facility Capacity */}
                  <div className="flex flex-row p-0 gap-3 h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-normal">
Total Emission reduction data:
                    </span>
                    <span className="h-6 text-[16px] leading-6 text-[#101828] font-medium">
{(
  Number(unverifiedDataGreen.quantifiedGHGEmissionsInBaselineScenario) - 
  Number(unverifiedDataGreen.totalGHGEmission) 
).toFixed(4)} tCO2e                    </span>
                  </div>
                </div>

                {/* Document Links */}
                <div className="flex flex-col p-0 gap-4">
                  {/* Energy Consumption Data */}
                  <div className="flex flex-row p-0 gap-14 h-6 mb-5">
                    <span className="h-6 text-[16px] leading-6 text-[#101828] ">
                      Energy consumption data:
                    </span>
                    <button className="flex flex-row  p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                      <Link
                        to={`/iot-details-for-verifier/${unverifiedDataGreen.plantAddress}`}
                        className="w-[39px] h-6 font-inter font-semibold text-[16px] leading-6 underline text-[#038B47]"
                      >
                        View
                      </Link>
                    </button>
                  </div>

                  {/* KYC */}
                  <div className="flex flex-row  p-0 gap-14 w-[295px] h-6 mb-5">
                    <span className="w-[198px] h-6 font-inter font-normal text-[16px] leading-6 text-[#101828]">
                      KYC:
                    </span>
                    <button className="flex flex-row  p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                      <Link
                        to={`/kcy/verifier/${unverifiedDataGreen.plantAddress}`}
                        className="w-[39px] h-6  text-[16px] font-semibold leading-6 underline text-[#038B47] mr-2"
                      >
                        View
                      </Link>
                    </button>
                  </div>

                  {/* Quantification Methodology */}
                    <div className="flex flex-row  p-0 gap-10 w-[295px] h-6 mb-5">
                    <span className="w-[215px] h-6 text-[16px] leading-6 text-[#101828] ">
                      Quantification methodology:
                    </span>
                    <a
                      href={normalizedMethodologyUrl || undefined}
                      target={normalizedMethodologyUrl ? "_blank" : undefined}
                      rel={
                        normalizedMethodologyUrl
                          ? "noopener noreferrer"
                          : undefined
                      }
                      aria-disabled={!normalizedMethodologyUrl}
                      className="flex flex-row  p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity"
                    >
                      <span className="w-[39px] h-6  text-[16px] leading-6 underline font-semibold text-[#038B47] mr-2">
                        View
                      </span>
                    </a>
                  </div>
              

                  {/* Project Design Document */}
                  <div className="flex flex-row items-center p-0 gap-[61px] w-[295px] h-6">
                    <span className="w-[194px] h-6 font-inter font-normal text-[16px] leading-6 text-[#101828]">
                      Project design document:
                    </span>
                    <button className="flex flex-row justify-center items-center p-0 gap-3 w-[39px] h-6 rounded-xl hover:opacity-80 transition-opacity">
                      <span className="w-[39px] h-6 font-inter font-semibold text-[16px]  leading-6 underline text-[#038B47] mr-12">
                        N/A
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Emission Data Table */}
            <div className="w-full mt-8">

              {!loading && unverifiedDataGreen && (
                <div className="box-border w-full h-[582px] border border-[#E5E5E5] rounded-2xl">
                  <div className="flex flex-col items-start p-0 w-full h-[582px]">
                    {/* Table Header */}
                    <div className="flex flex-col justify-center items-center p-0 w-full h-[52px] bg-[#2C9963] rounded-t-2xl">
                      <div className="flex flex-row justify-center items-center p-0 w-full h-[48px]">
                        {/* Date Column */}
                        <div className="flex flex-row justify-center items-center pr-2.5 w-[130px] h-[48px]">
                          <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[52px] h-8 rounded-lg">
                            <span className="w-[32px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                              Date
                            </span>
                          </div>
                        </div>

                        {/* Project Emission Column */}
                        <div className="flex flex-row justify-center items-center pr-2.5 w-[205px] h-[48px]">
                          <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[163px] h-8 rounded-lg">
                            <span className="w-[143px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                              Project emission data
                            </span>
                          </div>
                        </div>

                        {/* Baseline Emission Column */}
                        <div className="flex flex-row justify-center items-center pr-2.5 w-[241px] h-[48px]">
                          <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[172px] h-8 rounded-lg">
                            <span className="w-[152px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                              Baseline emission data
                            </span>
                          </div>
                        </div>

                        {/* Energy Consumption Column */}
                        <div className="flex flex-row justify-center items-center pr-2.5 w-[243px] h-[48px]">
                          <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[192px] h-8 rounded-lg">
                            <span className="w-[172px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                              Total energy consumption
                            </span>
                          </div>
                        </div>

                        {/* Emission Reduction Column */}
                        <div className="flex flex-row justify-center items-center pr-2.5 w-[210px] h-[48px]">
                          <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[179px] h-8 rounded-lg">
                            <span className="w-[159px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-white">
                              Emission reduction data
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Table Body */}
                    <div className="flex flex-col items-start p-0 w-full h-[424px] overflow-y-auto">
                      {currentRecords.map((record, index) => (
                        <div
                          key={
                            record.id ?? `${record.date ?? "record"}-${index}`
                          }
                          className="flex flex-col justify-center items-center p-0 w-full h-[52px] bg-white "
                        >
                          <div className="flex flex-row justify-center items-center p-0 w-full h-[48px]">
                            {/* Date */}
                            <div className="flex flex-row justify-center items-center  w-[100px] h-[48px]">
                              <div className="flex flex-row justify-center items-center p-2 gap-1.5  h-8 rounded-lg">
                                <span className="w-full h-[18px] font-normal text-[14px] leading-[18px] text-[#101828] whitespace-nowrap">
                                  {formatDate(record.date)}
                                </span>
                              </div>
                            </div>

                            {/* Project Emission */}
                            <div className="flex flex-row justify-center items-center pr-2.5 w-[205px] h-[48px]">
                              <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                <span className="font-inter font-normal text-[14px] leading-[18px] text-[#101828] whitespace-nowrap">
                                  {record.totalGHGEmission}tCO2e
                                </span>
                              </div>
                            </div>

                            {/* Baseline Emission */}
                            <div className="flex flex-row justify-center items-center pr-2.5 w-[241px] h-[48px]">
                              <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[92px] h-8 rounded-lg">
                                <span className="w-[72px] h-[18px] font-inter font-normal text-[14px] leading-[18px] text-[#101828]">
                                  {
                                    record.quantifiedGHGEmissionsInBaselineScenario
                                  }e
                                </span>
                              </div>
                            </div>

                            {/* Energy Consumption */}
                            <div className="flex flex-row justify-center items-center pr-2.5 w-[243px] h-[48px]">
                              <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[122px] h-8 rounded-lg">
                                <span className="font-inter font-normal text-[14px] leading-[18px] text-[#101828] whitespace-nowrap">
                                  {record.energyConsumptionInKWh} {" "}kWh
                                </span>
                              </div>
                            </div>

                            {/* Emission Reduction */}
                            <div className="flex flex-row justify-center items-center pr-2.5 w-[210px] h-[48px]">
                              <div className="flex flex-row justify-center items-center p-2 gap-1.5 w-[101px] h-8 rounded-lg">
                                <span className="font-inter font-normal text-[14px] leading-[18px] text-[#101828] whitespace-nowrap">
                                  {/* {record.emissionReduction} */}
                                  {/* {record.quantifiedGHGEmissionsInBaselineScenario -
                                    record.totalGHGEmission}tCO2e */}
                                    {(
                                    record.quantifiedGHGEmissionsInBaselineScenario -
                                    record.totalGHGEmission
                                  ).toFixed(4)}{" "} tCO2e
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Pagination */}
                    <div className="flex flex-row justify-end items-center px-6 py-3 w-full h-[62px]">
                      <div className="flex flex-row items-center p-0 gap-4 w-auto h-[37px]">
                        <button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                          className={`flex flex-row justify-center items-center p-2 gap-2 w-[90px] h-[37px] border border-[#E5E5E5] rounded-lg transition-colors ${currentPage === 1
                            ? "bg-gray-100 cursor-not-allowed"
                            : "bg-white hover:bg-gray-50"
                            }`}
                        >
                          <span
                            className={`w-[58px] h-[21px] font-inter font-medium text-[14px] leading-[21px] ${currentPage === 1
                              ? "text-gray-400"
                              : "text-[#101828]"
                              }`}
                          >
                            Previous
                          </span>
                        </button>
                        <button
                          onClick={handleNextPage}
                          disabled={
                            totalPages === 0 || currentPage >= totalPages
                          }
                          className={`flex flex-row justify-center items-center p-2 gap-2 w-[64px] h-[37px] border border-[#E5E5E5] rounded-lg transition-colors ${currentPage === totalPages
                            ? "bg-gray-100 cursor-not-allowed"
                            : "bg-white hover:bg-gray-50"
                            }`}
                        >
                          <span
                            className={`w-[32px] h-[21px] font-inter font-medium text-[14px] leading-[21px] ${currentPage === totalPages
                              ? "text-gray-400"
                              : "text-[#101828]"
                              }`}
                          >
                            Next
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Comment Modal */}
        {openCommentModal && (
          <div
            className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${isClosing ? "opacity-0" : "opacity-100"
              }`}
          >
            <div
              className={`relative w-[600px] h-[584px] bg-white rounded-2xl transform transition-transform duration-300 ${isClosing ? "scale-95" : "scale-100"
                }`}
            >
              {/* Back Button */}
              <div className="absolute left-6 top-9">
                <div
                  className="flex flex-row items-center gap-0.5 cursor-pointer"
                  onClick={handleCloseCommentModal}
                >
                  {/* Back Arrow Icon */}
                  <div className="w-6 h-6">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z"
                        fill="#000000"
                      />
                      <path
                        d="M5.56086 12L11.7814 18.219C11.9222 18.3598 12.0013 18.5508 12.0013 18.75C12.0013 18.9491 11.9222 19.1401 11.7814 19.281C11.6405 19.4218 11.4495 19.5009 11.2504 19.5009C11.0512 19.5009 10.8602 19.4218 10.7194 19.281L3.96936 12.531C3.89952 12.4613 3.84411 12.3785 3.8063 12.2874C3.76849 12.1963 3.74902 12.0986 3.74902 12C3.74902 11.9013 3.76849 11.8036 3.8063 11.7125C3.84411 11.6214 3.89952 11.5386 3.96936 11.469L10.7194 4.71897C10.8602 4.57814 11.0512 4.49902 11.2504 4.49902C11.4495 4.49902 11.6405 4.57814 11.7814 4.71897C11.9222 4.8598 12.0013 5.05081 12.0013 5.24997C12.0013 5.44913 11.9222 5.64014 11.7814 5.78097L5.56086 12Z"
                        fill="#000000"
                      />
                    </svg>
                  </div>
                  {/* Back Text */}
                  {/* <span className="font-medium text-xs leading-[15px] text-[#2C2C2C]">
                                        Back
                                    </span> */}
                </div>
              </div>

              {/* Title */}
              <div className="absolute left-1/2 top-8 transform -translate-x-1/2">
                <h2 className="font-medium text-2xl leading-9 text-[#101828] text-center">
                  Leave Comment
                </h2>
              </div>

              {/* Content Area */}
              <div className="absolute left-6 top-[100px] w-[552px] h-[452px] flex flex-col gap-8">
                {/* Comment Section */}
                <div className="flex flex-col gap-8 w-full h-[364px]">
                  <div className="flex flex-col gap-3 w-full h-full">
                    {/* Comment Label */}
                    <label className="font-semibold text-[16px] leading-6 text-[#101828]">
                      Comment
                    </label>

                    {/* Textarea */}
                    <div className="flex flex-row items-start p-5 gap-2.5 w-full h-[328px] border border-[#667185] border-opacity-50 rounded-lg ">
                      <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        className="w-full h-full resize-none outline-none font-normal text-[16px] leading-[21px] text-[#101828] placeholder-[#667185]"
                        placeholder="Enter your comment here..."
                      />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  className={`flex flex-row justify-center items-center py-2 px-4 gap-3 w-full h-14 rounded-lg ${comment.trim() && !commentLoading
                    ? "bg-gradient-to-r from-[#038B47] to-[#00AED9] cursor-pointer hover:opacity-90"
                    : "bg-gray-300 cursor-not-allowed"
                    }`}
                  onClick={handleCommentSubmit}
                  disabled={!comment.trim() || commentLoading}
                >
                  {commentLoading && (
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                  )}
                  <span className="font-semibold text-[15px] leading-6 text-white">
                    {commentLoading ? "Submitting..." : "Submit"}
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Verification Confirmation Modal */}
        {openVerifyModal && (
          <div
            className={`fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300 ${isClosing ? "opacity-0" : "opacity-100"
              }`}
          >
            <div
              className={`relative w-[600px] h-[338px] bg-white rounded-2xl transform transition-transform duration-300 ${isClosing ? "scale-95" : "scale-100"
                }`}
            >
              {/* Close Button */}
              <div className="absolute right-6 top-6 ">
                <button
                  onClick={handleCloseVerifyModal}
                  className="w-8 h-8 cursor-pointer hover:bg-gray-100 rounded transition-colors flex items-center justify-center"
                  disabled={verificationLoading}
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.899 1.49906C15.299 1.64906 17.549 2.84906 19.199 4.49906C21.149 6.59906 22.199 9.14906 22.199 12.1491C22.199 14.5491 21.299 16.7991 19.799 18.7491C18.299 20.5491 16.199 21.8991 13.799 22.3491C11.399 22.7991 8.99896 22.4991 6.89896 21.2991C4.79896 20.0991 3.14896 18.2991 2.24896 16.0491C1.34896 13.7991 1.19896 11.2491 1.94896 8.99906C2.69896 6.59906 4.04896 4.64906 6.14896 3.29906C8.09896 1.94906 10.499 1.34906 12.899 1.49906ZM13.649 20.8491C15.599 20.3991 17.399 19.3491 18.749 17.6991C19.949 16.0491 20.699 14.0991 20.549 11.9991C20.549 9.59906 19.649 7.19906 17.999 5.54906C16.499 4.04906 14.699 3.14906 12.599 2.99906C10.649 2.84906 8.54896 3.29906 6.89896 4.49906C5.24896 5.69906 4.04896 7.34906 3.44896 9.44906C2.84896 11.3991 2.84896 13.4991 3.74896 15.4491C4.64896 17.3991 5.99896 18.8991 7.79896 19.9491C9.59896 20.9991 11.699 21.2991 13.649 20.8491ZM11.849 11.2491L15.449 7.49906L16.499 8.54906L12.899 12.2991L16.499 16.0491L15.449 17.0991L11.849 13.3491L8.24896 17.0991L7.19896 16.0491L10.799 12.2991L7.19896 8.54906L8.24896 7.49906L11.849 11.2491Z"
                      fill="#667185"
                    />
                  </svg>
                </button>
              </div>

              {/* Content Area */}
              <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[450px] h-[212px] flex flex-col items-center gap-8">
                {/* Text Content */}
                <div className="flex flex-col items-center gap-4 w-[428px] h-[124px]">
                  {/* Title */}
                  <h2 className="font-semibold text-[24px] leading-9 text-[#101828] text-center mb-5">
                    Confirm Verification
                  </h2>

                  {/* Description */}
                  <p className="font-normal text-[16px] leading-6 text-[#667185] text-center w-full">
                    By proceeding, you affirm that all data and information meet
                    the required standard, and all procedures are standard
                    throughout the process.
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-row items-center justify-center gap-6 w-[600px] h-14">
                  {/* Cancel Button */}
                  <button
                    className="flex flex-row justify-center items-center py-2 px-4 gap-2 w-[199px] h-[56px] border border-[#667185] rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleCloseVerifyModal}
                    disabled={verificationLoading}
                  >
                    <span className="font-semibold text-[16px] leading-6 text-[#667185]">
                      Cancel
                    </span>
                  </button>

                  {/* Confirm Button */}
                  <button
                    className="flex flex-row justify-center items-center py-2 px-4 gap-2 w-[227px] h-[56px] bg-gradient-to-r from-[#038B47] to-[#00AED9] rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleVerifyConfirm}
                    disabled={verificationLoading}
                  >
                    {verificationLoading ? (
                      <div className="flex items-center gap-2">
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                        <span className="font-semibold text-[16px] leading-6 text-white">
                          Verifying...
                        </span>
                      </div>
                    ) : (
                      <span className="font-semibold text-[16px] leading-6 text-white">
                        Confirm Verification
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {
          success &&(
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-[24px]  relative p-8 md:p-12">
            {/* Close Button */}
            <button
              onClick={handleCloseOverlay}
              className="absolute top-12 right-12 w-6 h-6 flex items-center justify-center hover:opacity-70 transition-opacity"
              aria-label="Close"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {/* Success Icon */}
            <div className="flex justify-center mt-8">
              <div className="w-[200px] h-[200px] relative">
             <svg width="221" height="199" viewBox="0 0 221 199" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle opacity="0.05" cx="115" cy="107.001" r="92" fill="#038B47"/>
<path d="M111.728 135.239C107.261 135.237 102.858 134.176 98.8809 132.142C94.9037 130.108 91.4658 127.16 88.8496 123.539C86.2334 119.919 84.5135 115.729 83.8313 111.314C83.149 106.9 83.5239 102.386 84.9251 98.1448C86.3262 93.9032 88.7137 90.0546 91.8914 86.9151C95.0691 83.7756 98.9463 81.4349 103.204 80.0851C107.463 78.7353 111.98 78.415 116.386 79.1506C120.792 79.8862 124.961 81.6566 128.55 84.3164C129.03 84.7067 129.341 85.2672 129.419 85.8812C129.496 86.4953 129.333 87.1155 128.965 87.6126C128.596 88.1098 128.05 88.4455 127.44 88.55C126.83 88.6545 126.203 88.5196 125.69 88.1734C121.454 85.0285 116.281 83.4044 111.008 83.5637C105.735 83.723 100.669 85.6565 96.6309 89.0513C92.5926 92.4462 89.8175 97.104 88.7544 102.272C87.6912 107.439 88.4023 112.814 90.7724 117.527C93.1426 122.241 97.0334 126.017 101.816 128.245C106.598 130.473 111.992 131.023 117.125 129.805C122.258 128.588 126.831 125.675 130.104 121.537C133.376 117.399 135.157 112.278 135.158 107.002C135.155 105.766 135.055 104.533 134.858 103.313C134.809 102.997 134.823 102.675 134.898 102.365C134.974 102.055 135.11 101.762 135.299 101.505C135.487 101.247 135.725 101.029 135.997 100.863C136.27 100.697 136.573 100.586 136.889 100.537C137.204 100.489 137.526 100.502 137.837 100.578C138.147 100.653 138.439 100.789 138.697 100.978C138.955 101.166 139.173 101.404 139.339 101.677C139.505 101.95 139.615 102.253 139.664 102.568C139.879 104.036 139.979 105.518 139.965 107.002C139.958 114.489 136.981 121.667 131.687 126.961C126.393 132.255 119.215 135.232 111.728 135.239Z" fill="#34A853"/>
<path d="M114.726 116.014C114.09 116.011 113.48 115.756 113.032 115.305L101.617 103.89C101.223 103.431 101.017 102.839 101.041 102.234C101.064 101.63 101.315 101.056 101.743 100.628C102.171 100.2 102.745 99.9491 103.349 99.9258C103.954 99.9024 104.546 100.108 105.005 100.502L114.726 110.21L143.672 81.2768C144.131 80.8831 144.723 80.6774 145.327 80.7008C145.932 80.7241 146.506 80.9749 146.934 81.4028C147.362 81.8308 147.613 82.4045 147.636 83.0093C147.659 83.6142 147.454 84.2055 147.06 84.6652L116.42 115.305C115.972 115.756 115.362 116.011 114.726 116.014Z" fill="#34A853"/>
<path opacity="0.1" d="M138.765 7.04922C137.905 6.81372 137.047 6.82323 136.067 6.8341C135.822 6.83681 135.577 6.83953 135.331 6.84225C136.545 5.72613 137.758 4.61001 138.601 3.25296C138.842 2.88273 138.347 2.52065 138.105 2.76837C136.647 3.88721 135.312 5.12719 133.978 6.36717C133.96 4.77462 133.943 3.18207 133.925 1.58952C133.917 0.854495 132.814 0.86672 132.822 1.60174C132.84 3.1943 132.859 4.90935 132.877 6.5019C131.761 5.41159 130.648 4.44379 129.534 3.47598C129.04 3.1139 128.434 3.73321 128.928 4.09529C129.797 5.06582 130.665 6.03634 131.657 7.0055C130.431 7.01909 129.206 7.03267 127.982 7.16876C127.492 7.17419 127.5 7.90922 127.99 7.90378C129.462 8.00999 130.81 7.99504 132.158 7.9801C131.066 8.97236 129.975 10.0871 129.007 11.2005C128.522 11.696 129.264 12.3003 129.75 11.9274C130.842 10.9351 131.936 10.0654 132.905 9.07449C132.92 10.422 132.936 11.8921 133.196 13.2369C133.199 13.4819 133.689 13.4765 133.809 13.2301C134.041 12.0024 134.026 10.6548 134.011 9.30727C134.381 9.5482 134.63 9.913 135.001 10.1539C135.743 10.7583 136.485 11.3627 137.225 11.8445C137.473 12.0868 137.837 11.7152 137.589 11.4729C136.968 10.7447 136.47 10.0151 135.849 9.28689C135.476 8.80095 134.982 8.43887 134.61 8.07544C135.223 8.06865 135.713 8.06321 136.325 8.05642C137.306 8.04555 138.041 8.0374 139.019 7.78153C139.14 7.65767 139.134 7.16765 138.765 7.04922Z" fill="#030229"/>
<path opacity="0.1" d="M12.0129 68.8706C11.1524 68.6351 10.2946 68.6446 9.31428 68.6555C9.0692 68.6582 8.82412 68.6609 8.57903 68.6636C9.79223 67.5475 11.0054 66.4314 11.8483 65.0744C12.0893 64.7041 11.595 64.342 11.3527 64.5898C9.7705 65.5875 8.43748 66.9499 7.1031 68.1899C7.08545 66.5974 7.0678 65.0048 7.05014 63.4123C7.04199 62.6772 5.93912 62.6895 5.94727 63.4245C5.96492 65.017 5.98393 66.7321 6.00159 68.3247C4.88649 67.2343 3.77276 66.2665 2.65902 65.2987C2.16478 64.9367 1.55886 65.556 2.0531 65.918C2.92176 66.8886 3.79041 67.8591 4.78161 68.8283C3.55619 68.8418 2.33078 68.8554 1.10672 68.9915C0.616553 68.9969 0.624701 69.732 1.11487 69.7265C2.58672 69.8327 3.93468 69.8178 5.28263 69.8029C4.19062 70.7951 3.09997 71.9099 2.13186 73.0233C1.64713 73.5187 2.38917 74.1231 2.87526 73.7501C3.96727 72.7579 5.06064 71.8881 6.03011 70.8972C6.04504 72.2448 6.06134 73.7148 6.32136 75.0597C6.32408 75.3047 6.81424 75.2992 6.93407 75.0529C7.16557 73.8251 7.15063 72.4776 7.13569 71.13C7.50603 71.371 7.75519 71.7357 8.12553 71.9767C8.86757 72.581 9.60961 73.1854 10.3503 73.6673C10.5981 73.9096 10.9616 73.538 10.7138 73.2957C10.093 72.5675 9.59467 71.8379 8.97382 71.1096C8.60076 70.6237 8.10652 70.2616 7.73482 69.8982C8.34753 69.8914 8.8377 69.886 9.4504 69.8792C10.4307 69.8683 11.166 69.8602 12.1436 69.6043C12.2648 69.4804 12.2594 68.9904 12.0129 68.8706Z" fill="#030229"/>
<path d="M32.6396 28.3334C31.2835 27.6133 30.05 26.8919 29.056 25.6777C27.9382 24.3424 27.4304 22.7553 26.6775 21.1709C26.6775 21.1709 26.6762 21.0484 26.5536 21.0497L26.4311 21.0511C26.4311 21.0511 26.4311 21.0511 26.3099 21.175C26.3099 21.175 26.3099 21.175 26.3112 21.2975C25.9803 24.6091 24.0454 26.9584 21.6177 29.0682C21.4965 29.192 21.4992 29.437 21.6231 29.5582C24.3326 30.7533 26.2074 34.0406 27.0951 36.7262C27.2203 36.9698 27.5879 36.9657 27.7078 36.7194C28.1803 35.1214 28.5316 33.6473 29.3731 32.1677C30.2146 30.6881 31.3052 29.5734 32.6437 28.7009C32.7649 28.5771 32.7622 28.332 32.6396 28.3334Z" fill="#54B785"/>
<path d="M219.892 65.0828C218.536 64.3627 217.302 63.6413 216.431 62.4258C215.313 61.0904 214.805 59.5033 214.053 57.9189C214.053 57.9189 214.051 57.7964 213.929 57.7978L213.806 57.7991C213.806 57.7991 213.806 57.7991 213.685 57.923C213.685 57.923 213.685 57.923 213.686 58.0455C213.355 61.3572 211.42 63.7065 208.993 65.8162C208.871 65.9401 208.874 66.1851 208.998 66.3062C211.708 67.5014 213.582 70.7886 214.47 73.4742C214.595 73.7179 214.963 73.7138 215.083 73.4674C215.555 71.8694 215.907 70.3953 216.748 68.9158C217.59 67.4362 218.68 66.3214 220.019 65.449C220.019 65.449 220.016 65.204 219.892 65.0828Z" fill="#54B785"/>
<path d="M130.094 34.9583C129.109 34.4791 128.368 33.9973 127.623 33.1479C126.877 32.176 126.497 31.0775 125.872 29.9818C125.872 29.9818 125.872 29.9818 125.75 29.9832L125.627 29.9845C125.627 29.9845 125.627 29.9845 125.628 30.107C125.409 32.4373 124.079 34.0448 122.38 35.5339C122.258 35.6577 122.26 35.7802 122.382 35.7789C124.352 36.6147 125.604 38.9287 126.237 40.7594C126.239 41.0044 126.607 41.0004 126.604 40.7554C126.837 39.6501 127.193 38.5435 127.794 37.5567C128.396 36.5698 129.123 35.8267 130.097 35.2033C130.22 35.2019 130.217 34.9569 130.094 34.9583Z" fill="#54B785"/>
<path d="M98.8371 56.8061C97.112 55.9676 95.7545 55.125 94.6353 53.6672C93.2684 51.9671 92.6353 50.1363 91.7558 48.1858C91.7558 48.1858 91.7544 48.0633 91.6319 48.0646L91.5093 48.066C91.5093 48.066 91.3868 48.0673 91.3882 48.1898L91.3895 48.3123C90.9428 52.2379 88.6471 55.2038 85.7333 57.6865C85.6121 57.8104 85.6162 58.1779 85.8613 58.1751C89.1862 59.6085 91.4354 63.5042 92.4524 66.8009C92.579 67.1671 93.0692 67.1617 93.1876 66.7928C93.6574 64.9498 94.2498 63.1054 95.2111 61.3795C96.1724 59.6536 97.5054 58.2911 99.2101 57.2921C98.965 57.2948 99.0835 56.9259 98.8371 56.8061Z" fill="#54B785"/>
<path d="M69.4543 25.9516C67.7115 23.5206 65.9701 21.212 63.7427 19.2764C62.5064 18.31 61.2701 17.3435 59.914 16.6234C59.1747 16.2641 58.4367 16.0272 57.6974 15.6679C57.3284 15.5494 56.9594 15.431 56.5891 15.1901C56.2201 15.0716 55.9723 14.8293 55.606 14.9559C55.3609 14.9586 55.2398 15.0825 55.365 15.3261C55.4943 15.9373 56.2337 16.2967 56.7279 16.6587C57.3461 17.142 57.9628 17.5027 58.581 17.9859C59.8159 18.8299 61.0522 19.7963 62.1659 20.7641C64.2708 22.7011 66.0095 24.7646 67.6284 27.0746C68.3758 28.1689 70.2031 27.1685 69.4543 25.9516Z" fill="#FF8F6B"/>
<path d="M68.5809 75.1048C67.5747 72.7881 65.2329 71.5889 62.8937 70.6347C60.5546 69.6805 57.8492 68.8528 55.4024 69.2475C53.0768 69.5183 50.5198 71.0169 49.6864 73.2315C49.0914 74.8308 48.5044 77.1652 49.9885 78.3739C50.7319 79.1008 52.0812 79.2084 52.8083 78.4652C54.0215 77.3491 52.8996 75.6462 51.9098 74.7996C47.8252 71.1693 40.9697 71.8579 36.4587 73.9907C33.6538 75.247 31.2261 77.3567 29.7868 80.1906C28.5859 82.4093 27.2814 86.3443 28.9002 88.6542C29.1494 89.019 29.6395 89.0136 29.8805 88.6434C31.2081 86.7909 31.1782 84.0958 32.1369 82.1249C33.0941 80.0314 34.6681 78.2987 36.494 77.1758C40.2657 74.6836 46.7468 73.3866 50.698 76.0382C51.1922 76.4003 52.5497 77.2429 51.8226 77.986C51.2167 78.6054 50.2295 78.0037 49.8565 77.5178C48.3561 74.839 51.8772 71.8595 54.0762 71.2225C56.2751 70.5855 58.8553 71.1695 60.948 72.004C63.2844 72.7132 65.9953 74.0308 67.365 75.976C67.9804 76.2142 68.8328 75.7147 68.5809 75.1048Z" fill="#EF37FF"/>
<path d="M176.156 55.6435C176.278 55.6421 176.277 55.5196 176.154 55.521C176.032 55.5223 176.033 55.6448 176.156 55.6435Z" fill="#3F3937"/>
<path d="M177.24 53.5486C179.28 49.6054 183.523 45.3927 188.318 46.8098C190.039 47.2808 192.263 48.8489 192.042 51.0567C191.936 52.5281 190.209 51.5671 189.59 50.9613C188.102 49.3851 188.806 46.5593 189.275 44.7164C189.983 42.2581 191.551 39.9129 193.618 38.4198C195.318 37.0532 197.64 36.4149 199.72 36.1468C202.046 35.8759 204.137 36.5879 206.348 37.0534C207.207 37.1664 207.809 36.1796 207.19 35.5739C205.578 33.8765 202.757 33.6627 200.554 33.9322C198.228 34.203 195.784 34.8427 193.838 36.212C189.945 38.828 187.066 44.3733 187.485 49.0244C187.753 51.1042 190.492 54.9945 192.796 52.7636C193.888 51.7713 193.5 49.9378 192.996 48.7182C192.118 46.8902 190.144 45.6869 188.3 45.2172C182.77 43.8083 178.532 48.511 176.501 53.1893C176.382 53.5581 176.999 53.9188 177.24 53.5486Z" fill="#EF37FF"/>
<path d="M71.2249 48.4887C69.4821 46.0576 67.256 44.2445 64.6691 43.048C63.3143 42.4504 61.9609 41.9754 60.6103 41.7453C59.3821 41.5139 57.5426 41.4117 56.4466 42.0365C56.2028 42.1617 56.2069 42.5292 56.4547 42.7715C57.4418 43.3732 58.9137 43.4794 60.0193 43.7121C61.3713 44.0647 62.4783 44.42 63.7105 45.0189C66.051 46.0957 68.2744 47.6638 69.8891 49.6062C70.51 50.3344 71.8471 49.3394 71.2249 48.4887Z" fill="#FF8F6B"/>
<path d="M43.2576 57.0076C44.3578 56.7504 45.5818 56.6143 46.6847 56.6021C47.2974 56.5953 47.9101 56.5885 48.5228 56.5817C48.8905 56.5776 49.2581 56.5735 49.5018 56.4483C49.7455 56.3231 49.9906 56.3204 50.2343 56.1952C50.4781 56.0699 50.474 55.7024 50.2276 55.5826C49.9811 55.4628 49.7347 55.3431 49.6108 55.2219C49.3643 55.1021 48.8742 55.1076 48.6277 54.9878C48.015 54.9946 47.4023 55.0014 46.6684 55.132C45.4444 55.2681 44.2217 55.5267 43.0003 55.9078C42.2664 56.0384 42.5237 57.1383 43.2576 57.0076Z" fill="#FF8F6B"/>
<path d="M173.803 86.1769C177.211 84.0563 180.868 82.3005 184.777 81.1545C186.61 80.6441 188.565 80.1323 190.523 79.8656C191.625 79.7308 192.604 79.5975 193.705 79.4627C194.563 79.4532 195.421 79.4437 196.152 79.0681C196.396 78.9428 196.392 78.5753 196.145 78.4555C195.283 78.0975 194.427 78.2296 193.447 78.2404C192.344 78.2526 191.365 78.386 190.262 78.3982C188.18 78.5438 186.101 78.9344 184.023 79.4476C179.868 80.4738 176.212 82.3521 172.81 85.0852C172.326 85.5807 173.072 86.5525 173.803 86.1769Z" fill="#FF8F6B"/>
<path d="M166.999 80.4938C169.906 77.3986 173.682 75.2739 177.335 73.1506C179.162 72.1502 181.111 71.0259 183.062 70.1467C184.159 69.6444 185.134 69.1435 186.109 68.6426C187.084 68.1418 188.184 67.8845 189.158 67.2611C189.402 67.1359 189.397 66.7684 189.028 66.65C188.045 66.4158 186.947 66.7956 185.968 66.9289C184.744 67.065 183.645 67.4448 182.547 67.947C180.352 68.9515 178.159 70.0785 176.089 71.3266C172.07 73.5765 168.542 75.9435 165.764 79.6499C165.281 80.2678 166.392 80.9906 166.999 80.4938Z" fill="#FF8F6B"/>
<path d="M146.866 22.5204C146.74 22.1542 146.736 21.7867 146.608 21.2981C146.605 21.0531 146.481 20.9319 146.48 20.8094C146.478 20.6869 146.477 20.5644 146.353 20.4433C146.352 20.3208 146.229 20.3221 146.228 20.1996C146.104 20.0785 145.98 19.9573 145.857 19.9587C145.735 19.96 145.614 20.0839 145.492 20.2078C145.494 20.3303 145.371 20.3316 145.373 20.4541C145.374 20.5766 145.375 20.6991 145.377 20.8216C145.379 21.0666 145.382 21.3117 145.507 21.5553C145.511 21.9228 145.638 22.289 145.765 22.6551L145.763 22.5326L145.765 22.6551C145.766 22.7776 145.891 23.0213 146.015 23.1424C146.139 23.2636 146.386 23.3834 146.507 23.2595C146.629 23.2581 146.873 23.1329 146.872 23.0104C146.872 23.0104 146.869 22.7654 146.866 22.5204Z" fill="#030229"/>
<path d="M151.963 40.1069C152.05 36.9204 152.999 34.0919 154.07 31.1396C154.666 29.6628 155.264 28.3084 155.984 26.9527C156.705 25.597 157.428 24.4864 157.779 23.0122C157.776 22.7672 157.527 22.4024 157.285 22.6502C156.677 23.147 156.314 23.5186 155.83 24.1365C155.47 24.7531 155.11 25.4922 154.749 26.1088C154.03 27.587 153.311 29.0652 152.716 30.6645C151.646 33.6169 151.07 36.9313 150.983 40.1177C151.112 40.7289 151.97 40.7194 151.963 40.1069Z" fill="#FF8F6B"/>
<path d="M162.279 19.4092C162.399 19.1629 162.52 19.039 162.64 18.7926C162.64 18.7926 162.641 18.9152 162.519 18.9165C162.519 18.9165 162.518 18.794 162.64 18.7926L162.761 18.6688C162.882 18.5449 162.882 18.5449 163.004 18.4211C163.245 18.0508 163.61 17.8017 163.851 17.4315C164.092 17.0613 164.456 16.8122 164.697 16.442C164.817 16.1956 165.061 16.0704 165.181 15.824C165.179 15.7015 165.302 15.7002 165.301 15.5777C165.422 15.4538 165.42 15.3313 165.419 15.2088C165.539 14.9624 165.29 14.5976 164.922 14.6017C164.8 14.6031 164.677 14.6044 164.432 14.6071C164.309 14.6085 164.311 14.731 164.188 14.7324C164.188 14.7324 164.188 14.7324 164.066 14.7337C164.188 14.7324 164.188 14.7324 164.066 14.7337C163.821 14.7364 163.578 14.9842 163.335 15.1094C162.847 15.3598 162.484 15.7314 162.12 16.103C161.756 16.4746 161.393 16.8462 161.153 17.3389C160.912 17.7091 160.55 18.2032 160.432 18.5721C160.191 18.9423 160.32 19.5535 160.813 19.7931C161.549 19.9074 162.038 19.7795 162.279 19.4092Z" fill="#FF8F6B"/>
<path d="M158.245 42.365C158.602 41.3809 159.082 40.5179 159.439 39.5338C159.796 38.5497 160.154 37.6881 160.633 36.7026C161.114 35.8397 161.471 34.8556 161.951 33.9926C162.432 33.1296 163.158 32.264 163.269 31.2826C163.265 30.915 162.896 30.7966 162.651 30.7993C161.674 31.0552 161.196 32.1632 160.591 32.905C159.865 33.7707 159.386 34.7561 158.907 35.7416C158.427 36.7271 158.071 37.7112 157.715 38.8178C157.598 39.3092 157.359 39.8019 157.365 40.4144C157.248 40.9058 157.255 41.5183 157.26 42.0083C157.145 42.6222 158.005 42.8577 158.245 42.365Z" fill="#FF8F6B"/>
<path d="M164.956 28.9361C165.194 28.3209 165.556 27.8268 165.919 27.3327C166.401 26.5922 166.636 25.732 167.119 25.114C167.603 24.4961 168.213 24.2443 168.82 23.7475C169.427 23.2507 170.035 22.7538 170.641 22.1345C172.944 19.9037 175.619 17.9137 178.419 16.2899C179.151 15.9142 179.882 15.5386 180.613 15.1629C181.1 14.9125 181.83 14.4143 181.456 13.8059C180.83 12.5876 178.396 14.2073 177.665 14.583C174.864 16.2068 172.562 18.5602 170.012 20.6713C169.282 21.1694 168.676 21.7888 168.07 22.4081C167.464 23.0274 166.983 23.8903 166.377 24.5096C165.772 25.129 165.04 25.5046 164.434 26.1239C163.95 26.6194 163.59 27.3585 163.353 28.0962C162.874 29.0817 164.355 30.0454 164.956 28.9361Z" fill="#FF8F6B"/>
<path opacity="0.5" d="M106.94 36.0726C107.42 35.0871 107.529 33.8607 107.394 32.7595C107.38 31.5345 107.244 30.3108 106.987 29.211C106.984 28.966 106.494 28.9714 106.497 29.2164C106.386 30.3203 106.399 31.4228 106.412 32.6479C106.423 33.6279 106.435 34.7304 106.077 35.5921C105.839 36.2073 106.702 36.6878 106.94 36.0726Z" fill="#EF37FF"/>
<g opacity="0.5">
<path d="M107.011 20.1444C106.999 19.0419 107.109 17.938 106.976 16.9593C106.841 15.8581 106.463 14.8822 105.839 13.9089C105.714 13.6653 105.225 13.7932 105.352 14.1594C105.864 16.114 105.887 18.1966 105.91 20.2791C105.794 20.893 107.019 20.8794 107.011 20.1444Z" fill="#EF37FF"/>
</g>
<path opacity="0.5" d="M101.501 9.66887C101.245 8.69156 100.867 7.7156 100.367 6.86351C100.118 6.49871 99.9899 6.01006 99.7408 5.64526C99.4916 5.28046 99.2384 4.54816 98.7482 4.55359C98.5031 4.55631 98.2581 4.55902 98.1382 4.80539C97.8986 5.29812 98.2716 5.78406 98.5221 6.27136C98.7713 6.63616 99.0218 7.12346 99.1484 7.48961C99.6481 8.34171 100.025 9.19516 100.28 10.05C100.533 10.7823 101.754 10.4012 101.501 9.66887Z" fill="#EF37FF"/>
<path opacity="0.5" d="M107.124 7.89132C107.359 6.90857 107.469 5.80468 107.579 4.70078C107.574 4.21077 107.567 3.59825 107.562 3.10823C107.556 2.61822 107.549 2.0057 107.299 1.5184C107.172 1.15224 106.682 1.15768 106.564 1.52655C106.324 2.01928 106.331 2.6318 106.336 3.12182C106.342 3.61183 106.347 4.10185 106.352 4.59186C106.363 5.5719 106.252 6.55329 106.14 7.53468C106.143 7.77968 106.269 8.14584 106.514 8.14312C106.762 8.38541 107.128 8.25883 107.124 7.89132Z" fill="#EF37FF"/>
<path opacity="0.5" d="M111.816 11.3922C112.047 10.1644 112.525 9.05648 113.127 8.06965C113.729 7.08283 114.577 6.21579 115.302 5.22761C115.422 4.98125 115.295 4.61509 115.051 4.74031C113.707 5.12277 112.739 6.23617 112.139 7.3455C111.416 8.45618 111.063 9.8078 110.832 11.0356C110.595 11.7733 111.702 12.1286 111.816 11.3922Z" fill="#EF37FF"/>
<path d="M192.874 59.5014C192.995 59.3776 192.994 59.2551 193.115 59.1312C193.235 58.8848 193.354 58.6385 193.352 58.3935C193.349 58.1485 193.348 58.026 193.467 57.7796L193.466 57.6571C193.465 57.5346 193.463 57.4121 193.462 57.2896C193.459 57.0446 193.457 56.7996 193.331 56.5559C193.329 56.3109 193.205 56.1897 193.081 56.0686C192.83 55.5813 192.336 55.2192 191.722 55.1035C191.968 55.2233 192.215 55.3431 192.463 55.5854C192.215 55.3431 191.968 55.2233 191.723 55.226C191.477 55.1062 191.232 55.1089 191.111 55.2328C190.866 55.2355 190.744 55.3594 190.501 55.4846C190.257 55.6098 190.015 55.8576 189.895 56.1039C190.26 55.8548 190.502 55.6071 190.867 55.358C190.744 55.3594 190.623 55.4833 190.501 55.4846C190.257 55.6098 190.013 55.735 189.892 55.8589C189.771 55.9828 189.65 56.1066 189.528 56.2305C189.53 56.353 189.407 56.3544 189.409 56.4769C189.41 56.5994 189.289 56.7232 189.29 56.8457C189.411 56.7219 189.409 56.4769 189.53 56.353C189.531 56.4755 189.409 56.4769 189.41 56.5994C189.411 56.7219 189.289 56.7232 189.29 56.8457C189.169 56.9696 189.172 57.2146 189.051 57.3385C188.931 57.5848 188.811 57.8312 188.815 58.1987C188.695 58.4451 188.822 58.8112 188.824 59.0562C188.95 59.2999 189.075 59.5435 189.2 59.7872C189.325 60.0308 189.573 60.2731 189.82 60.3929C189.944 60.5141 190.189 60.5113 190.313 60.6325C190.682 60.7509 191.172 60.7455 191.538 60.6189C191.659 60.495 191.904 60.4923 192.025 60.3685C192.513 60.118 192.754 59.7478 192.874 59.5014Z" fill="#FF8F6B"/>
<path d="M187.984 17.0415C187.982 16.919 187.86 16.9204 187.859 16.7978C187.735 16.6767 187.611 16.5556 187.609 16.4331C187.609 16.4331 187.485 16.3119 187.363 16.3133C187.117 16.1935 187.115 16.071 186.746 15.9525C186.624 15.9539 186.377 15.8341 186.255 15.8355C186.132 15.8368 185.887 15.8395 185.887 15.8395L185.521 15.9661C185.277 16.0914 185.156 16.2152 185.036 16.4616C184.915 16.5854 184.915 16.5854 184.916 16.7079C184.918 16.8304 184.795 16.8318 184.796 16.9543C184.677 17.2007 184.558 17.5695 184.562 17.9371C184.566 18.3046 184.691 18.5482 184.818 18.9144C185.193 19.5228 185.809 19.8835 186.422 19.8767C187.035 19.87 187.766 19.4943 188.004 18.8791C188.124 18.6327 188.242 18.2638 188.238 17.8963C188.236 17.6513 188.11 17.4077 187.984 17.0415Z" fill="#FF8F6B"/>
<path d="M97.839 32.7431C96.822 29.4464 97.2728 25.8883 97.8489 22.5739C97.8461 22.3289 97.5997 22.2091 97.4799 22.4555C96.2911 25.7767 95.9656 29.5784 96.984 32.9976C96.9907 33.6102 97.9684 33.3543 97.839 32.7431Z" fill="#030229"/>
</svg>

              </div>
            </div>

            {/* Success Content */}
            <div className="text-center mt-6">
              <h3 className="text-[32px] font-semibold text-[#3B3B3B] tracking-[-0.02em] mb-3">
              Facility verified successfully!
              </h3>
              {/* <p className="text-[20px] text-[#898989] tracking-[-0.02em] max-w-[567px] mx-auto">
                Thank you for submitting your advertisement request. Our partnerships team will reach out to{' '}
                <span className="text-[#3B3B3B] font-medium"> </span> within 24 hours.
              </p> */}
            </div>

            {/* Action Button */}
            {/* <div className="flex justify-center mt-8">
              <button
                // onClick={handleCloseOverlay}
                className="w-full max-w-[400px] h-[77px] bg-[#0D924F] hover:bg-[#0B7A41] text-white text-[24px] font-medium rounded-[12px] border-2 border-[#E4E7EC] transition-colors duration-200"
              >
                Got it
              </button>
            </div> */}
          </div>
        </div>
          )
        }
      </div>
    </div>
  );
}

export default Web3VerificationData;
